// Tiny, safe-enough markdown renderer for our known answer structure.
// Handles: ## headings, > blockquotes (with citation on next line), paragraphs, *em*, **strong**.
// Escapes HTML first to prevent injection.

function esc(s) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function inline(s) {
  // bold
  s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  // italics
  s = s.replace(/(^|[^*])\*([^*\n]+)\*/g, "$1<em>$2</em>");
  return s;
}

export function renderMarkdown(md) {
  if (!md) return "";
  const lines = esc(md).split(/\r?\n/);
  const out = [];
  let i = 0;
  let paraBuf = [];

  const flushPara = () => {
    if (paraBuf.length) {
      out.push(`<p>${inline(paraBuf.join(" "))}</p>`);
      paraBuf = [];
    }
  };

  while (i < lines.length) {
    const line = lines[i];

    if (/^\s*$/.test(line)) {
      flushPara();
      i++;
      continue;
    }

    // Heading ##
    if (/^##\s+/.test(line)) {
      flushPara();
      out.push(`<h2>${inline(line.replace(/^##\s+/, ""))}</h2>`);
      i++;
      continue;
    }

    // Blockquote: gather consecutive > lines
    if (/^>\s?/.test(line)) {
      flushPara();
      const bq = [];
      while (i < lines.length && /^>\s?/.test(lines[i])) {
        bq.push(lines[i].replace(/^>\s?/, ""));
        i++;
      }
      out.push(`<blockquote>${bq.map(inline).join("<br/>")}</blockquote>`);
      continue;
    }

    // List item
    if (/^[-*]\s+/.test(line)) {
      flushPara();
      const items = [];
      while (i < lines.length && /^[-*]\s+/.test(lines[i])) {
        items.push(`<li>${inline(lines[i].replace(/^[-*]\s+/, ""))}</li>`);
        i++;
      }
      out.push(`<ul>${items.join("")}</ul>`);
      continue;
    }

    paraBuf.push(line);
    i++;
  }
  flushPara();
  return out.join("\n");
}
